import { render, staticRenderFns } from "./ExpedicaoDetalhes.vue?vue&type=template&id=00e1a278&scoped=true"
import script from "./ExpedicaoDetalhes.vue?vue&type=script&lang=js"
export * from "./ExpedicaoDetalhes.vue?vue&type=script&lang=js"
import style0 from "./ExpedicaoDetalhes.vue?vue&type=style&index=0&id=00e1a278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e1a278",
  null
  
)

export default component.exports